export function constructMetadataFromStrapiData(
  data: StrapiSeoSharedComponent
) {
  const metadata = [
    {
      property: 'description',
      content: data.description ?? ''
    },
    {
      property: 'og:title',
      content: data.title
    },
    {
      property: 'og:description',
      content: data.description ?? ''
    },
    {
      property: 'og:type',
      content: 'website'
    }
  ]

  if (data.featuredImage.data?.attributes.url) {
    metadata.push({
      property: 'og:image',
      content: data.featuredImage.data.attributes.url
    })
  }

  return metadata
}
